import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * emailチェッククラス
 */
export default class EFOcats_validate_email extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'email') {
      return new EFOcats_error_info('success', '', '', '');
    }

    const material_val = checkData.val();

    if (material_val.match(/^[A-Za-z0-9\w-.+]+[A-Za-z0-9\w-+]@[\w-][\w.-]+\.\w{2,}$/)) {
      // 連続で.を使用
      if (material_val.indexOf('..') >= 0) {
        return new EFOcats_error_info('error', this.langagerList('メールエラー'), '', 'メールエラー');
      }

      // 先頭が.
      if (material_val.substring(0, 1) === '.') {
        return new EFOcats_error_info('error', this.langagerList('メールエラー'), '', 'メールエラー');
      }

      // ローカル部が64文字以上
      if (material_val.substring(0, material_val.indexOf('@')).length > 64) {
        return new EFOcats_error_info('error', this.langagerList('メールエラー'), '', 'メールエラー');
      }

      // ドメイン部が254文字以上
      if (material_val.substring(material_val.indexOf('@') + 1).length > 254) {
        return new EFOcats_error_info('error', this.langagerList('メールエラー'), '', 'メールエラー');
      }

      return new EFOcats_error_info('success', '', '', '');
    }
    return new EFOcats_error_info('error', this.langagerList('メールエラー'), '', 'メールエラー');
  }
}
